export default __webpack_public_path__ + "static/media/kanban_card.37349504.svg";